module.exports = __webpack_public_path__ + "img/article_11_4.aecaf3b0.webp";